document.addEventListener("DOMContentLoaded", function(){
  document.querySelectorAll('.scroll-to-cart-text').forEach(function(el){
    el.addEventListener('click', function(e){
      e.preventDefault();
      var target = document.getElementById('AddToCart');
      if(target){
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  });
});
